(function() {
  var btn = document.getElementById('see-more-button');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var additionalSections = document.getElementById('additional-sections');
    var seeMoreText = this.getAttribute('data-see-more');
    var seeLessText = this.getAttribute('data-see-less');
    if (additionalSections.style.display === 'none') {
      additionalSections.style.display = 'block';
      this.textContent = seeLessText;
    } else {
      additionalSections.style.display = 'none';
      this.textContent = seeMoreText;
    }
  });
})();
